export default __webpack_public_path__ + "static/calzaretta-2cac7e8247f4b4d9d543c0133e317c19.jpg";